export default __webpack_public_path__ + "static/smart_redirect-3ece03a8b731fa38da6dad2b8a43b114.svg";